import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map, shareReplay, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AuthTokenStoreService } from './auth-token-store.service';

@Injectable({
  providedIn: 'root',
})
export class AuthRefreshService {
  private refreshInFlight$?: Observable<any>;

  constructor(
    private readonly http: HttpClient,
    private readonly authTokenStore: AuthTokenStoreService
  ) {}

  refreshToken(): Observable<any> {
    if (this.refreshInFlight$) {
      return this.refreshInFlight$;
    }

    const accessToken = this.authTokenStore.getAccessToken();
    const payload = {
      payload: {
        refreshToken: this.authTokenStore.getRefreshToken() ?? undefined,
      },
    };

    const request$ = this.http.post<any>(
      `${environment.apiUrl}auth/refresh-token`,
      payload,
      {
        headers: new HttpHeaders({
          'content-type': 'application/json',
          ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
        }),
        withCredentials: true,
      }
    ).pipe(
      map((response) => {
        const newAccessToken = response?.data?.access_token ?? null;
        const newRefreshToken = response?.data?.refresh_token ?? null;
        const userId = this.authTokenStore.getUserId() ?? localStorage.getItem('userID');

        if (newAccessToken) {
          this.authTokenStore.storeSessionTokens(
            {
              userId,
              accessToken: newAccessToken,
              refreshToken: newRefreshToken,
            },
            true
          );
        }

        try {
          window.dispatchEvent(new CustomEvent('sv:auth-token-refreshed', {
            detail: {
              at: Date.now(),
              userID: userId,
            },
          }));
        } catch {
          // no-op
        }

        return newAccessToken ?? '';
      }),
      catchError((error) => throwError(() => error)),
      finalize(() => {
        this.refreshInFlight$ = undefined;
      }),
      shareReplay({ bufferSize: 1, refCount: true })
    );

    this.refreshInFlight$ = request$;
    return request$;
  }
}
